import { render } from "./alert-homero.vue?vue&type=template&id=e2caaaf2&scoped=true&ts=true"
import script from "./alert-homero.vue?vue&type=script&lang=ts"
export * from "./alert-homero.vue?vue&type=script&lang=ts"

import "./alert-homero.vue?vue&type=style&index=0&id=e2caaaf2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2caaaf2"]])

export default __exports__